import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { breadcrumb } from '../../../shared/interface/breadcrumb.interface';
import { Cart } from '../../../shared/interface/cart.interface';
import { Values } from '../../../shared/interface/setting.interface';
import { Option } from '../../../shared/interface/theme-option.interface';
import { CartState } from '../../../shared/store/state/cart.state';
import { SettingState } from '../../../shared/store/state/setting.state';
import { ThemeOptionState } from '../../../shared/store/state/theme-option.state';
import { ButtonComponent } from '../../../shared/components/widgets/button/button.component';
import { AuthService } from '../../../core/services/api/auth.service';
import { UserLoginReqVM } from '../../../core/models/api/user.model';
import { DeviceTypeEnum, ResponseCodeEnum, SystemNameEnum } from '../../../core/enums/common.enum';
import Swal from 'sweetalert2';
import { NotificationService } from '../../../shared/services/notification.service';
import { Login } from '../../../shared/store/action/auth.action';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule,
            ReactiveFormsModule, TranslateModule, ButtonComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  @Select(CartState.cartItems) cartItem$: Observable<Cart[]>;
  @Select(SettingState.setting) setting$: Observable<Values>;
  @Select(ThemeOptionState.themeOptions) themeOption$: Observable<Option>;

  @Output() activeForm: EventEmitter<string> = new EventEmitter();

  public validate: boolean = false;
  public loginForm: FormGroup;

  mobileView: boolean = false;

  constructor(
    private notificationService: NotificationService,
    private authService: AuthService,
    public formBuilder: FormBuilder,
    private store: Store,
    private router: Router,
    private modalService: NgbModal,
  ){
    this.onResize();
      this.loginForm = this.formBuilder.group({
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', Validators.required),
      })
    }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if(window && window?.innerWidth <= 768){
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }    
  }

  submit(isforcedlogin:boolean = false){
    this.validate = true;
    if(this.loginForm.valid){
      const payload:UserLoginReqVM = {
        email: this.loginForm.value?.email,
        password: this.loginForm.value?.password,
        systemName: SystemNameEnum.DESKTOP,
        deviceType: DeviceTypeEnum.DESKTOP,
        isforcedlogin: isforcedlogin
      }
      this.authService.login(payload).subscribe({
        next: (res:any)=>{
          if (res?.responseCode === ResponseCodeEnum.SUCCESS) {
            this.store.dispatch(new Login(res?.data))
            this.notificationService.showSuccess(res?.message);
            this.backForm();
          }else {
            this.notificationService.showError(res?.Message ? res?.Message : res?.message);
          }
        },
        error: (err)=>{
          if (err?.status === 409) {
            Swal.fire({
              title: 'Are you sure?',
              text: err?.message,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Proceed',
              reverseButtons: true,
              heightAuto: false,
          }).then((result) => {
              if (result?.isConfirmed) {
                this.submit(true);
              }
          });
          }else{
            this.notificationService.showError(err?.message);
          }          
        }
      })
      // this.store.dispatch(new Login(this.loginForm.value)).subscribe({
      //   complete: () => {
      //     this.modalService.dismissAll();
      //     // Sync Cart Storage when successfully Login
      //     let syncCartItems: CartAddOrUpdate[] = [];
      //     this.cartItem$.subscribe(items => {
      //       items.filter(item => {
      //         if(item) {
      //           const params: CartAddOrUpdate = {
      //             id: null,
      //             product: item?.product,
      //             product_id: item?.product_id,
      //             variation: item?.variation ? item.variation : null,
      //             variation_id: item?.variation_id ? item.variation_id : null,
      //             quantity: item.quantity
      //           }
      //           syncCartItems.push(params);
      //         }
      //       });
      //     });
      //     if(syncCartItems.length) {
      //       this.store.dispatch(new SyncCart(syncCartItems));
      //     } else {
      //       this.store.dispatch(new GetCartItems());
      //     }

      //     this.authService.redirectUrl = undefined;
      //   }
      // })
    }
  }

  loginWithNumber(){
    this.activeForm.emit('withNumber');
  }

  action(action: string){
    this.activeForm.emit(action);
  }

  
  backForm(){
    if (this.mobileView) {
      this.router.navigateByUrl('/');  
      this.modalService.dismissAll();
    }else{
      window?.location?.reload();
    }
  }
}
